import QuickReplies from '../components/QuickReplies';

const QuickRepliesContainer = QuickReplies;

export default QuickRepliesContainer;
